import { createFileRoute } from '@tanstack/react-router'
import { ObjectView } from 'pages/objectViews/ObjectView'
import { FC } from 'react'
import { prismSearchParams } from 'routes/prism/-searchParams'

const RouteComponent: FC = () => {
  const { entryId, orgId, siteId } = Route.useSearch()

  return <ObjectView entryId={entryId} orgId={orgId} siteId={siteId} />
}

export const Route = createFileRoute('/prism/')({
  component: RouteComponent,
  staticData: {
    title: 'Object View',
  },
  validateSearch: prismSearchParams,
})
